import { Link } from "react-router-dom";
import { Phone, Calendar } from "lucide-react";
import { BUSINESS } from "@/lib/config";

export default function Nav() {
  return (
    <>
      <header
        data-testid="site-nav"
        className="fixed top-0 inset-x-0 z-50 backdrop-blur-2xl bg-black/70 border-b border-white/10"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3 shrink-0">
            <img src={BUSINESS.logo} alt="OTGG" className="logo-blend h-10 w-10 md:h-12 md:w-12 object-contain" />
            <div className="leading-tight hidden xs:block sm:block">
              <div className="font-heading text-[13px] md:text-sm tracking-[0.18em] text-white uppercase">
                On The Go <span className="text-otgg-red">Gloss</span>
              </div>
              <div className="text-[9px] md:text-[10px] tracking-[0.3em] text-zinc-500 uppercase">Mobile Detailing</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8 text-sm text-zinc-400">
            <a href="/#services" data-testid="nav-services" className="hover:text-white transition-colors">Services</a>
            <a href="/#pricing" data-testid="nav-pricing" className="hover:text-white transition-colors">Pricing</a>
            <Link to="/fleet" data-testid="nav-fleet" className="hover:text-white transition-colors">Fleet</Link>
            <a href="/#contact" data-testid="nav-contact" className="hover:text-white transition-colors">Contact</a>
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={BUSINESS.phoneHref}
              data-testid="nav-call-btn"
              className="inline-flex items-center gap-1.5 px-3 md:px-4 h-10 rounded-full border border-white/20 text-white hover:border-white transition-colors text-xs md:text-sm"
            >
              <Phone size={13} /> <span className="hidden sm:inline">Call</span>
            </a>
            <Link
              to="/book"
              data-testid="nav-book-btn"
              className="inline-flex items-center gap-1.5 px-4 md:px-5 h-10 rounded-full bg-otgg-red text-white font-semibold hover:bg-otgg-red transition-colors text-xs md:text-sm"
            >
              <Calendar size={13} /> Book
            </Link>
          </div>
        </div>
      </header>
    </>
  );
}
